import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config/apiConfig';

const StatsPage = () => {
    const [stats, setStats] = useState({
        totalUsers: 0,
        activeUsers: 0,
        totalGenerations: 0,
        averageQuota: 0,
        monthlyData: []
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const authToken = JSON.parse(localStorage.getItem('authToken') || '{}');
                const response = await axios.get(`${API_URL}/admin/stats`, {
                    headers: {
                        Authorization: `Bearer ${authToken.token}`
                    }
                });

                if (response.data.success) {
                    setStats(response.data.data);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des statistiques:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    return (
        <div>
            <h1 className="text-2xl font-semibold text-gray-700 mb-6">Statistiques d'utilisation</h1>

            {loading ? (
                <p className="text-center py-4">Chargement des statistiques...</p>
            ) : (
                <>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                        <div className="bg-white rounded-lg shadow p-6">
                            <div className="text-sm font-medium text-gray-500">Utilisateurs totaux</div>
                            <div className="mt-2 text-3xl font-semibold text-gray-900">{stats.totalUsers}</div>
                        </div>

                        <div className="bg-white rounded-lg shadow p-6">
                            <div className="text-sm font-medium text-gray-500">Utilisateurs actifs</div>
                            <div className="mt-2 text-3xl font-semibold text-gray-900">{stats.activeUsers}</div>
                        </div>

                        <div className="bg-white rounded-lg shadow p-6">
                            <div className="text-sm font-medium text-gray-500">Générations de PDF</div>
                            <div className="mt-2 text-3xl font-semibold text-gray-900">{stats.totalGenerations}</div>
                        </div>

                        <div className="bg-white rounded-lg shadow p-6">
                            <div className="text-sm font-medium text-gray-500">Quota moyen</div>
                            <div className="mt-2 text-3xl font-semibold text-gray-900">{stats.averageQuota}</div>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow p-6">
                        <h2 className="text-lg font-medium text-gray-900 mb-4">Évolution mensuelle</h2>
                        <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center">
                            <p className="text-gray-500">Graphique d'évolution mensuelle</p>
                            {/* Ici, vous pourriez intégrer une bibliothèque de graphiques comme Chart.js ou Recharts */}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default StatsPage;